import { registerWithI18next } from '@linka/i18n/i18next';
import { messages as organizerMessages } from '@linka/i18n/messages/organizer';
import { messages as uiMessages } from '@linka/i18n/messages/ui';
import { type Locale, setDefaultOptions } from 'date-fns';
import { enUS, es, ptBR } from 'date-fns/locale';
import i18n, { type TFunction } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// em produção não precisamos do modo debug
const debug = import.meta.env.VITE_I18N_DEBUG === 'true';
export const resources = {
  pt: {
    translation: organizerMessages.pt,
  },
  en: {
    translation: organizerMessages.en,
  },
  es: {
    translation: organizerMessages.es,
  },
} as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'pt',
    supportedLngs: ['pt', 'en', 'es'],
    debug,
    interpolation: {
      escapeValue: false,
    },
    resources,
  });

registerWithI18next(i18n, 'ui', uiMessages);

export const getCurrentLanguage = (): string => i18n.language;

export function changeLanguage<T extends string = 'pt' | 'en' | 'es'>(languagePrefix: T): Promise<TFunction> {
  return i18n.changeLanguage(languagePrefix);
}

const locales: { [key: string]: Locale } = { pt: ptBR, en: enUS, es };
setDefaultOptions({ locale: locales[getCurrentLanguage()] });

export default i18n;
